// extracted by mini-css-extract-plugin
module.exports = {"title":"PublicCommitteeModal_title__2RLoH","divider":"PublicCommitteeModal_divider__CJsO2"};